import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll email you a secure reset link"
      footer={<Link to="/login" className="text-gold font-semibold hover:underline" data-testid="back-to-login-link">Back to sign in</Link>}
    >
      {sent ? (
        <div className="rounded-xl border-2 border-emerald-200 bg-emerald-50 p-6 text-center" data-testid="forgot-success">
          <MailCheck className="w-10 h-10 text-emerald-600 mx-auto mb-3" />
          <p className="text-navy font-semibold">Check your inbox</p>
          <p className="text-sm text-muted-foreground mt-1">If that email is registered, a reset link is on its way. The link expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">Work Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" placeholder="you@dealership.com" />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-navy hover:bg-navy-light text-white h-11" data-testid="forgot-submit-button">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Reset Link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
